// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__kRFN9","title":"BackImages_title__3zQQQ","images":"BackImages_images__16GCX"};